/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetHexForAppRouteQueryVariables = Types.Exact<{
  hexId: Types.Scalars["HexId"]["input"];
}>;

export type GetHexForAppRouteQuery = {
  readonly __typename: "Query";
  readonly hexById: {
    readonly __typename: "Hex";
    readonly id: c.HexId;
    readonly canEdit: boolean;
    readonly effectiveRole: Types.ProjectRole | null;
    readonly canViewLogic: boolean;
    readonly canCreateScheduledRuns: boolean;
    readonly projectLanguage: Types.ProjectLanguage;
    readonly starredByViewer: boolean;
    readonly trashDate: c.DateTimeString | null;
    readonly archivedDate: c.DateTimeString | null;
    readonly hexType: Types.HexType;
    readonly allowPublicDuplication: boolean;
    readonly isTemplateProject: boolean;
    readonly canCommentOnApp: boolean;
    readonly owner: { readonly __typename: "User"; readonly id: c.UserId };
    readonly lastPublishedVersion: {
      readonly __typename: "HexVersion";
      readonly id: c.HexVersionId;
      readonly title: string;
      readonly layoutType: Types.LayoutType | null;
      readonly canvasLayout: {
        readonly __typename: "CanvasLayout";
        readonly id: c.CanvasLayoutId;
        readonly width: number;
      };
    } | null;
    readonly org: {
      readonly __typename: "Org";
      readonly id: c.OrgId;
      readonly dataRetentionCellOutputsDays: number | null;
      readonly supportUserId: c.UserId | null;
    };
  };
};

export type HexVersionRoleCheckQueryVariables = Types.Exact<{
  hexId: Types.Scalars["HexId"]["input"];
  version: Types.Scalars["HexVersionString"]["input"];
  appSession: Types.InputMaybe<Types.Scalars["AppSessionId"]["input"]>;
}>;

export type HexVersionRoleCheckQuery = {
  readonly __typename: "Query";
  readonly safeHexVersionByNumber:
    | {
        readonly __typename: "AssetAccess";
        readonly hasAccessToSharedDataConnections: boolean;
        readonly hasAccessToSharedPackages: boolean;
        readonly hasAccessToSharedSecrets: boolean;
        readonly hasAccessToSharedSyncRepositories: boolean;
      }
    | { readonly __typename: "HexNotFound"; readonly hexId: c.HexId }
    | { readonly __typename: "HexVersion" }
    | {
        readonly __typename: "MissingProjectRole";
        readonly neededRoleV2: Types.ProjectRole;
        readonly currentRoleV2: Types.ProjectRole | null;
      };
};

export type RunEventBasedAppSessionMutationVariables = Types.Exact<{
  appSessionId: Types.Scalars["AppSessionId"]["input"];
  executeTrace: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
  forceOverwriteCache: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
}>;

export type RunEventBasedAppSessionMutation = {
  readonly __typename: "Mutation";
  readonly runEventBasedAppSession: string;
};

export const GetHexForAppRouteDocument = /*#__PURE__*/ gql`
  query GetHexForAppRoute($hexId: HexId!) {
    hexById(hexId: $hexId) {
      id
      canEdit
      effectiveRole
      canViewLogic
      canCreateScheduledRuns
      projectLanguage
      starredByViewer
      trashDate
      archivedDate
      hexType
      owner {
        id
      }
      allowPublicDuplication
      isTemplateProject
      canCommentOnApp
      lastPublishedVersion {
        id
        title
        canvasLayout {
          id
          width
        }
        layoutType
      }
      org {
        id
        dataRetentionCellOutputsDays
        supportUserId
      }
    }
  }
`;

/**
 * __useGetHexForAppRouteQuery__
 *
 * To run a query within a React component, call `useGetHexForAppRouteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHexForAppRouteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHexForAppRouteQuery({
 *   variables: {
 *      hexId: // value for 'hexId'
 *   },
 * });
 */
export function useGetHexForAppRouteQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetHexForAppRouteQuery,
    GetHexForAppRouteQueryVariables
  > &
    (
      | { variables: GetHexForAppRouteQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetHexForAppRouteQuery,
    GetHexForAppRouteQueryVariables
  >(GetHexForAppRouteDocument, options);
}
export function useGetHexForAppRouteLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetHexForAppRouteQuery,
    GetHexForAppRouteQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetHexForAppRouteQuery,
    GetHexForAppRouteQueryVariables
  >(GetHexForAppRouteDocument, options);
}
export function useGetHexForAppRouteSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetHexForAppRouteQuery,
    GetHexForAppRouteQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetHexForAppRouteQuery,
    GetHexForAppRouteQueryVariables
  >(GetHexForAppRouteDocument, options);
}
export type GetHexForAppRouteQueryHookResult = ReturnType<
  typeof useGetHexForAppRouteQuery
>;
export type GetHexForAppRouteLazyQueryHookResult = ReturnType<
  typeof useGetHexForAppRouteLazyQuery
>;
export type GetHexForAppRouteSuspenseQueryHookResult = ReturnType<
  typeof useGetHexForAppRouteSuspenseQuery
>;
export type GetHexForAppRouteQueryResult = Apollo.QueryResult<
  GetHexForAppRouteQuery,
  GetHexForAppRouteQueryVariables
>;
export const HexVersionRoleCheckDocument = /*#__PURE__*/ gql`
  query HexVersionRoleCheck(
    $hexId: HexId!
    $version: HexVersionString!
    $appSession: AppSessionId
  ) {
    safeHexVersionByNumber(
      hexId: $hexId
      version: $version
      appSession: $appSession
    ) {
      ... on AssetAccess {
        hasAccessToSharedDataConnections
        hasAccessToSharedPackages
        hasAccessToSharedSecrets
        hasAccessToSharedSyncRepositories
      }
      ... on HexNotFound {
        hexId
      }
      ... on MissingProjectRole {
        neededRoleV2
        currentRoleV2
      }
    }
  }
`;

/**
 * __useHexVersionRoleCheckQuery__
 *
 * To run a query within a React component, call `useHexVersionRoleCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useHexVersionRoleCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHexVersionRoleCheckQuery({
 *   variables: {
 *      hexId: // value for 'hexId'
 *      version: // value for 'version'
 *      appSession: // value for 'appSession'
 *   },
 * });
 */
export function useHexVersionRoleCheckQuery(
  baseOptions: Apollo.QueryHookOptions<
    HexVersionRoleCheckQuery,
    HexVersionRoleCheckQueryVariables
  > &
    (
      | { variables: HexVersionRoleCheckQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    HexVersionRoleCheckQuery,
    HexVersionRoleCheckQueryVariables
  >(HexVersionRoleCheckDocument, options);
}
export function useHexVersionRoleCheckLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    HexVersionRoleCheckQuery,
    HexVersionRoleCheckQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    HexVersionRoleCheckQuery,
    HexVersionRoleCheckQueryVariables
  >(HexVersionRoleCheckDocument, options);
}
export function useHexVersionRoleCheckSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    HexVersionRoleCheckQuery,
    HexVersionRoleCheckQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    HexVersionRoleCheckQuery,
    HexVersionRoleCheckQueryVariables
  >(HexVersionRoleCheckDocument, options);
}
export type HexVersionRoleCheckQueryHookResult = ReturnType<
  typeof useHexVersionRoleCheckQuery
>;
export type HexVersionRoleCheckLazyQueryHookResult = ReturnType<
  typeof useHexVersionRoleCheckLazyQuery
>;
export type HexVersionRoleCheckSuspenseQueryHookResult = ReturnType<
  typeof useHexVersionRoleCheckSuspenseQuery
>;
export type HexVersionRoleCheckQueryResult = Apollo.QueryResult<
  HexVersionRoleCheckQuery,
  HexVersionRoleCheckQueryVariables
>;
export const RunEventBasedAppSessionDocument = /*#__PURE__*/ gql`
  mutation RunEventBasedAppSession(
    $appSessionId: AppSessionId!
    $executeTrace: Boolean
    $forceOverwriteCache: Boolean
  ) {
    runEventBasedAppSession(
      appSessionId: $appSessionId
      executeTrace: $executeTrace
      forceOverwriteCache: $forceOverwriteCache
    )
  }
`;
export type RunEventBasedAppSessionMutationFn = Apollo.MutationFunction<
  RunEventBasedAppSessionMutation,
  RunEventBasedAppSessionMutationVariables
>;

/**
 * __useRunEventBasedAppSessionMutation__
 *
 * To run a mutation, you first call `useRunEventBasedAppSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunEventBasedAppSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runEventBasedAppSessionMutation, { data, loading, error }] = useRunEventBasedAppSessionMutation({
 *   variables: {
 *      appSessionId: // value for 'appSessionId'
 *      executeTrace: // value for 'executeTrace'
 *      forceOverwriteCache: // value for 'forceOverwriteCache'
 *   },
 * });
 */
export function useRunEventBasedAppSessionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RunEventBasedAppSessionMutation,
    RunEventBasedAppSessionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RunEventBasedAppSessionMutation,
    RunEventBasedAppSessionMutationVariables
  >(RunEventBasedAppSessionDocument, options);
}
export type RunEventBasedAppSessionMutationHookResult = ReturnType<
  typeof useRunEventBasedAppSessionMutation
>;
export type RunEventBasedAppSessionMutationResult =
  Apollo.MutationResult<RunEventBasedAppSessionMutation>;
export type RunEventBasedAppSessionMutationOptions = Apollo.BaseMutationOptions<
  RunEventBasedAppSessionMutation,
  RunEventBasedAppSessionMutationVariables
>;
